import { render, staticRenderFns } from "./ClientV2.vue?vue&type=template&id=110f8fef&scoped=true"
import script from "./ClientV2.vue?vue&type=script&lang=js"
export * from "./ClientV2.vue?vue&type=script&lang=js"
import style0 from "./ClientV2.vue?vue&type=style&index=0&id=110f8fef&prod&scoped=true&lang=css"
import style1 from "./ClientV2.vue?vue&type=style&index=1&id=110f8fef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110f8fef",
  null
  
)

export default component.exports